/**
 * @param {Object} payload
 * @returns {Object} copy without null, undefined or empty-string values
 */
const compact = (payload) =>
  Object.entries(payload).reduce((acc, [key, value]) => {
    if (value !== null && value !== undefined && value !== '') acc[key] = value
    return acc
  }, {})

export default compact
